module.exports = __webpack_public_path__ + "static/media/no-avatar.a4cae59f.png";